import { registerMocks as registerAlertMocks } from '../alerts';
import { registerMocks as registerViewMocks } from '../view';
import { registerMocks as registerWatchlistMocks } from '../watchlist';

const registerMocks = () =>
  Promise.all([registerAlertMocks(), registerViewMocks(), registerWatchlistMocks()]);

export default registerMocks;
